import type { ReactNode } from 'react'
import { kickerClass } from './classes'

/**
 * Small uppercase label. `label` is the grey section eyebrow (above panel
 * headings); `kicker` is the semibold line above a page or article title.
 */
export function Eyebrow({
  children,
  className = '',
  variant = 'label',
}: {
  children: ReactNode
  className?: string
  variant?: 'label' | 'kicker'
}) {
  if (variant === 'kicker') {
    return <p className={`${kickerClass} ${className}`}>{children}</p>
  }
  return (
    <div
      className={`text-base leading-6 font-medium tracking-wide md:text-xs md:leading-4 text-fg-muted uppercase ${className}`}
    >
      {children}
    </div>
  )
}
